import script from "./RegisterItemOption.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterItemOption.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./RegisterItemOption.vue?vue&type=style&index=1&id=18c4b9de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18c4b9de"]])

export default __exports__